import React from 'react';
import InspectionForm from '../InspectionForm';
import slug from 'constants/slug';
import { getOne as getFacility } from 'api/cosoApi';
import { create } from 'api/inspectionApi';
import Message from 'rc-message';
import PageLockHOC from 'hoc/pageLock';
import { getQueryString } from 'utils/fnUtil';
import _ from 'lodash';


@PageLockHOC(['facilityInspection.write'])
export default class InspectionCreate extends React.Component {
  static propTypes = {};

  state = {
    isLoaded: true,
    isLoading: false,
    facility: null,
    facilityId: ''
  };

  async checkValidate() {
    const queryString = getQueryString(this.props.location.search);
    const _id = queryString.facilityId;
    if (_id) {
      const res = await getFacility(_id);
      if (res.success) {
        this.setState({
          facility: res.data,
          facilityId: res.data._id,
          isLoading: false,
          isLoaded: true
        });
      }
    } else {
      //this.props.history.push(slug.CO_SO.LIST);
    }
  }

  async componentWillMount() {
    await this.checkValidate();
  }

  handelSubmit = async values => {
    // console.log(_.pickBy(values, _.identity), values, '_.identity');
    const res = await create(_.pickBy(values, _.identity));
    if (res.success) {
      Message.success({ content: 'Thành Công' });
      this.props.history.push(slug.INSPECTTION.VIEW_WITH_ID + _.get(res, 'data._id', ''));
      // window.history.back();
    }
    if (res.error) Message.error({ content: res.message });
  };

  render() {
    return (
      <div>
        {this.state.isLoaded && (
          <InspectionForm
            slugBack={slug.FACILITY_PERMIT.LIST}
            facility={this.state.facility ? this.state.facility : null}
            onSubmit={this.handelSubmit}
          />
        )}
      </div>
    );
  }
}

// export default PageLockHOC(['facilityInspection.write'])(InspectionCreate)



// WEBPACK FOOTER //
// ./src/containers/Inspection/InspectionCreate/index.js